/*
 * @Author: your name
 * @Date: 2020-12-04 16:29:12
 * @LastEditTime: 2023-01-06 16:57:53
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\common\api\common.js
 */
/**
 * smp服务器接口定义
 */
const mockApi = {
  // 用户登录
  userLogin: "/smp/login.json",
  // 用户登出
  userLogout: "/smp/logout.json",
  // 查询版本信息
  getVersionInfo: "/smp/getVersionInfo.json",
  // 查询用户权限菜单信息
  getSystemMenus: "/smp/getSystemMenus.json",
  // 查询用户快捷菜单信息
  getUserMenus: "/smp/getUserMenus.json",
  // 获取用户所关联中心列表
  getUserCenter: "/smp/getUserCenter2.json",
  // 获取首页未处理告警数量和未读消息数量
  getAlarmCount: "/smp/getAlarmCount.json",
  getUserLoginInfo: "/cms/account/queryLoginAccountInfo.json"
};
const commonApi = {
  // 用户登录
  userLogin: "/cas/login",
  // 宇视播放器信息
  playInfo: "/cms/accessportal/queryPlatSystemListApi.json",
  // 查询账户list
  queryAccountList: "/cms/account/queryResultsByPag.json", //
  // 用户退出登录
  userLogout: "/cas/ioclogout",
  // 菜单权限
  getQuickMenuList: "/cms/account/queryQuickMenuList.json",
  // get快捷菜单
  upQuickMenuList: "/cms/account/updateQuickMenu.json",
  // up快捷菜单
  getMenusByAccount: "/cms/account/getMenusByLoginAccount.json",
  // 获取子系统列表
  getSubsystemList: "/cms/subsystem/getSubsystemList.json",
  // 查询所有园区
  queryAreaDevGroups: "/cms/area/queryAreaDevGroupList/queryAreaDevGroups.json",
  // 数据字典
  getDics: "/common/queryEnumerateInfos.json",
  // getDeviceListByPage: '/bms/device/getDeviceListByPage.json', // 查询设备列表
  getDeviceListByPage: "/bms/device/getDeviceListByPageApi.json", // 查询设备列表
  getWorkGroupTree: "/cms/workgroup/querySecurityWorkGroupTree.json", //获取安保人员列表Tree
  //查询系统配置
  querySysConfig: "/cms/sysConfig/querySysConfigList.json",
  // 修改密码
  updatePass: "cms/account/changePassword.json",
  // 重置密码
  resetPass: "/cms/forgetpassword/resetPassword.json",
  // 上传文件
  uploadFile: "/common/file/batchFileload.json",
  // 上报告警
  operateAlarm: "/bas/safeEvent/operateAlarmApi.json", //上报告警
  video: {
    // 直播流向后台发送消息
    vpdTime: "/vas/video/refreshVideoStreamPullingTime.json",
    // 本地抓拍
    localSnap: "/vas/video/localSnap.json",
    // 一键抓拍全部
    localSnapList: "/vas/video/localSnapList.json",
    // 视频分享
    shareVideo: "/vas/video/shareVideo.json",
    // 查询录像视频--视频监控专用
    queryPlayBackVideoEventRtsp: "/vas/video/queryPlayBackVideoRtsp.json",
    // play/pause Video专用
    playOrPauseVideo: "/vas/video/updateVideoLiveStream.json",
    // 查询录像视频--实时告警，识别中心录像
    queryPlayBackVideoEventRtspTwo:
      "/vas/video/queryPlayBackVideoEventRtsp.json",
    // 查询实时视频播放地址
    queryRealTimeVideoRtsp: "/vas/video/queryRealTimeVideoRtsp.json",
    // 查询录像列表
    queryVideoTimeList: "/vas/video/queryVideoTimeList.json",
    // 查询录像流
    queryPlayBackVideoRtsp: "/vas/video/queryPlayBackVideoRtsp.json"
  }
};
let defaultApi = commonApi;
if (window.systemConfig.MOCK_SERVER.SWITCH) {
  defaultApi = mockApi;
}
if (window.systemConfig.MENU_STATIC) {
  defaultApi.getSystemMenus =
    "http://10.40.143.213:9003/mock/base/smp/getSystemMenus.json";
}
export default defaultApi;
